import React from "react";
import { Box, Typography } from "@mui/material";

import { ReturnType, Trade } from "../../../../types/models/Trade";
import {
  ArrowDownIcon,
  ArrowUpIcon,
  PriceArrowIcon,
} from "../../../../constants/icons";
import { colors } from "../../../../constants/colors";
import { getSymbolLogo } from "../../../../utils/tradeUtils";
import TimerWidget from "../../../../components/shared/TimerWidget";

interface MyTradeListItemProps {
  item: Trade;
  onClick?: (item: Trade) => void;
  active: boolean;
}

const MyTradeListItem: React.FC<MyTradeListItemProps> = ({
  item,
  onClick,
  active,
}) => {
  const renderPositionIcon = (positionType: ReturnType) => {
    if (positionType === "PROFIT") {
      return <ArrowUpIcon color="green" size={20} />;
    } else {
      return <ArrowDownIcon color="red" size={20} />;
    }
  };

  const returnPercent = item.return?.percent ?? 0;
  const returnAmount = item.return?.amount ?? 0;
  const closeTimeDate: Date = new Date(item.closingTime);
  const timestamp = closeTimeDate.getTime();

  return (
    <div
      className="my-trades__content-list_item"
      onClick={() => onClick && onClick(item)}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={getSymbolLogo(item.symbol, item.symbolLogo)}
          alt="symbol"
          style={{
            borderRadius: item?.symbolLogo ? "50%" : "0",
            width: 35,
            height: 35,
          }}
        />
        <div style={{ marginLeft: 10 }}>
          <Typography>{item.symbolName}</Typography>
          <div style={{ display: "flex" }}>
            <Typography
              variant="body2"
              sx={{ display: "flex" }}
              color={colors.darkGrey}
            >
              {item?.openingPrice?.toFixed(2)}
            </Typography>
            <PriceArrowIcon size={20} color={colors.darkGrey} />
            <Typography
              variant="body2"
              sx={{ display: "flex" }}
              color={colors.darkGrey}
            >
              {item?.closingPrice?.toFixed(2)}
            </Typography>
          </div>
        </div>
      </div>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ mr: 1 }}>
          {active && (
            <TimerWidget
              value={timestamp}
              timerRange={item.assetTimer.timer.timerRange}
              refetchTimers={() => {}}
            />
          )}
        </Box>
        <div>
          <Typography variant="body2">${item.investment}</Typography>
          <Typography
            variant="body2"
            color={returnAmount > item.investment ? "success" : "red"}
          >
            ${returnAmount.toFixed(2)}
          </Typography>
        </div>
      </Box>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div>{renderPositionIcon(item.return.type)}</div>
        <Typography
          variant="body2"
          color={returnPercent > 0 ? "success" : "white"}
        >
          {returnPercent > 0 && "+"}
          {returnPercent}%
        </Typography>
      </div>
    </div>
  );
};

export default MyTradeListItem;
